import Vue from 'vue';

/**
 * Creates a reactive global state using Vue.observable
 * @see {@link https://v2.vuejs.org/v2/api/#Vue-observable Vue Observable API}
 */

/**
 * @typedef {Object} PageLoadingState
 * @property {boolean} isOpen - Indicates whether the page loading state is active
 * @property {string} label - The text to display during the loading state
 */

/** @type {PageLoadingState} */
const state = Vue.observable({
  isOpen: false,
  label: '',
});

/**
 * Hook to manage global page loading state
 *
 * @example
 * const { open, close } = useFullPageLoading();
 *
 * open('Please wait...');
 * close();
 */
export function useFullPageLoading() {
  /**
   * Opens the page loading overlay
   * @param {string} label - The text to display in the loading overlay
   */
  const open = label => {
    const DEFAULT_LABEL = 'Loading...';

    state.isOpen = true;
    state.label = label || DEFAULT_LABEL;
  };

  /**
   * Closes the page loading overlay and resets the label
   */
  const close = () => {
    state.isOpen = false;
    state.label = '';
  };

  return {
    open,
    close,
  };
}

export const pageLoadingState = state;
